/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=61e42df9&"
import script from "./accordion-item.vue?vue&type=script&lang=ts&"
export * from "./accordion-item.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./accordion-item.vue?vue&type=style&index=0&id=61e42df9&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports